module.exports = __webpack_public_path__ + "img/CW.47233e1f.png";